module.exports = __webpack_public_path__ + "static/assets/ddfe82a80c9428360c45490fd749a70f.svg";